import { useEffect, useState } from 'react';
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, TableSortLabel, Checkbox, Grid } from '@mui/material';
import DeletePopUp from '../../../../shared_elements/components/DeletePopUp';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { RegionList, RegionCRU } from '../components';
import { deleteOperatingRegionEscalationApi, getOperatingRegionEscalationApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import { PageLoader, Pagination, STableLoader } from '../../../../shared_elements';
import { useParams } from 'react-router-dom';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { enqueueSnackbar } from 'notistack';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getStorage } from '../../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const RegionHd = ({ sortInfo, createSortHandler, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Operating Region Esc`, page_type: page_type, })
    }
    const tableSorting = (key, name, hideIcon = false) => (
        <TableSortLabel
            hideSortIcon={hideIcon}
            disabled={hideIcon}
            sx={{ whiteSpace: "nowrap" }}
            active={sortInfo?.sort_by === key}
            direction={sortInfo?.sort_by === key ? sortInfo.sort : 'asc'}
            onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
        >
            <span style={{ color: sortInfo?.sort_by === key ? '#496ac5' : 'inherit' }}>
             {name}
           </span>
        </TableSortLabel>
    );

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "region_escalation", operationType: ['D'] }}> <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper> Action(s)
                </TableCell>
                <TableCell sx={{minWidth: "100px", whiteSpace: 'nowrap'}}>{tableSorting('name', 'Region')}</TableCell>
                <TableCell sx={{minWidth: '140px', whiteSpace: 'nowrap'}}>{tableSorting('escalation_percentage', 'Escalation Percentage(%)')}</TableCell>
                <TableCell sx={{minWidth: "100px", whiteSpace: 'nowrap'}}>{tableSorting('remarks', 'Remarks')}</TableCell>
                <TableCell sx={{minWidth: "100px", whiteSpace: 'nowrap'}}>{tableSorting('status', 'Status')}</TableCell>
            </TableRow>
        </TableHead>
    );
};

const OperatingRegion = () => {
    const dispatch = useDispatch()
    const {fileUploadDetails} = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [regionInfo, setRegionInfo] = useState({ list: [], pagination: {} });
    const [addEditRegion, setAddEditRegion] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
    const [deleteRegion, setDeleteRegion] = useState({ modal: false, data: null, })
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
    const[isExport,seIsExport]=useState(false)
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})
    

    useEffect(() => {
        const uploadedFileData = getApiResponse("region_escalation", slug);
        getRegionList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed',{ page_title: 'Operating Region Esc'})
        setUploadFileProgressData({uploadedFileData});
    }, []);

    const getRegionList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getOperatingRegionEscalationApi(params, query))
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                if (checkApiStatus(response)) {
                    setRegionInfo(response.data.data);
                }
            })
         dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"region_escalation"}))
            
        }

    const deleteOperatingRegionOperationFn = () => {
        setLoading(true);
        const idsToDelete = deleteRegion?.modal && deleteRegion?.data?.id ? [deleteRegion?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteOperatingRegionEscalationApi(params), { ids:idsToDelete } )
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Operating Region Esc`, success_msg: response?.data?.message, item_ids: deleteRegion?.data || bulk?.ids, response: response?.data })
                    setDeleteRegion({ modal: false, data: null });
                    getRegionList('fetch', {
                    page: regionInfo?.pagination?.current_page || 1,
                    per_page: regionInfo?.pagination?.per_page || 20,
                    });
                    setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Operating Region Esc`, error_msg: response?.data?.message, item_ids: deleteRegion?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditRegion?.modal) {
            setAddEditRegion({
                ...addEditRegion,
                data: {
                    ...addEditRegion.data,
                    attachments: addEditRegion.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getRegionList('', { per_page: regionInfo?.pagination?.per_page || 50 });
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk(prevBulk => ({ ...prevBulk, type: 'bulk', ids: flag ? item : [] }));
        }
        else {
            setBulk(prevBulk => ({ ...prevBulk, type: 'single', ids: flag ? [...prevBulk.ids, item] : prevBulk.ids.filter(optionItem => optionItem.id !== item.id) }));
        }
    };

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getRegionList('', { ...sortQuery, per_page: regionInfo?.pagination?.per_page });
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getOperatingRegionEscalationApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Operating Region Esc`, page_type: page_type, })
    }

    const handleUpload = async (slug, mode) => {
     setSlug({slug:slug})
      await fileUpload({
      attachments: fileUploadDetails.attachments,
      module_name: "region_escalation",
      slug: slug,
      query: { record_action_type: mode },
      onStart: () => setLoading(true),
      onComplete: () => setLoading(false),
      onProgress: ({ progressRefs, attachments ,response}) => {
               setUploadFileProgressData({ progressRefs, attachments ,response});
      },
     onSuccess: (success_msg) => {
      enqueueSnackbar(success_msg, {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" }
      });
       getRegionList("", { per_page: regionInfo?.pagination?.per_page || 50 });
     },
     onError: (err) => {
      enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" }
      });
     }
     });
      setSlug({})
    };  

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
                <LeasesNav type="technical"/>
                <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='flex-end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText={"Operating Region Esc."} type="technical"/>           
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right'}}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "region_escalation", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {regionInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "region_escalation", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'>
                                            <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={() => { setAddEditRegion({ modal: true, data: { name: "", escalation_percentage: '', status: null, remarks: "" }, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Operating Region Escalation</Button>
                                        </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: regionInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                            {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                                <Table className="mui-table-format" stickyHeader>
                                    <RegionHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={regionInfo?.list} toggleBulkOps={toggleBulkOps} />
                                    <TableBody>
                                        {regionInfo?.list?.length > 0 && regionInfo?.list?.map((item, index) => {
                                             const uploadedFileData = getApiResponse("region_escalation", item?.slug);

                                            return (
                                                <RegionList
                                                    slug={slug?.slug}
                                                    uploadedFileData={uploadedFileData }
                                                    uploadFileProgressData={uploadFileProgressData}
                                                    viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                    key={index}
                                                    item={item}
                                                    bulk={bulk}
                                                    viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                    onEditFn={() => setAddEditRegion({ modal: true, data: item, mode: 'edit' })}
                                                    onView={() => setAddEditRegion({ modal: true, data: item, mode: 'view' })}
                                                    onDeleteEolFn={() => {
                                                        setDeleteRegion({ modal: true, data: item, });
                                                        setBulk({modal: false, ids: [item], type: ''});
                                                    }}
                                                    toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                    onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                                                />
                                            )
                                        }
                                        )}
                                    </TableBody>
                                </Table>
                            )}
                            {!skeletonLoader && !regionInfo?.list?.length && <NoRecordFound />}
                        </div>
                        <Paper square>
                            <Pagination
                                pagination={regionInfo?.pagination} onPageChange={(event, newPage) => { const pageNum = newPage + 1; getRegionList("Pageloader", { page: pageNum, per_page: regionInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }} onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getRegionList("Pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                            />
                        </Paper>
                    </Paper>
                </div>
            </Paper>

            {
                addEditRegion?.modal &&
                <RegionCRU
                    params={params}
                    fileUpload={handleUpload}
                    regionInfo={regionInfo}
                    modeType={addEditRegion?.mode}
                    addEditRegion={addEditRegion}
                    onOpenAttachments={() => setAttachments({ modal: true, data: addEditRegion?.data, mode:'view' })}
                    getResponseBack={() => {getRegionList("fetch", { per_page: regionInfo.pagination.per_page }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onToggleModal={() => setAddEditRegion({ modal: false, mode: '', data: null })}
                />
            }
            {deleteRegion.modal &&
                <DeletePopUp
                    modal={deleteRegion.modal}
                    title='Delete Operating Region Escalation'
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => {setDeleteRegion({ modal: false, data: null }); setBulk({ modal: false, ids: [], type: ''})}}
                    onDeleteRecords={() => deleteOperatingRegionOperationFn()}
                />}
            {attachments.modal ?
                <ShowAttachments
                    url='delete-attachment'
                    moduleName="Operating Region Escalation"
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
                    onViewDisabled={addEditRegion?.mode === 'view' || attachments?.mode==='view'}
                    permissionKey='region_escalation'
                /> : null
            }
            {bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal}
                    title={`Delete ${bulk?.type === "bulk" && bulk?.ids?.length > 0 && bulk?.ids?.length === (regionInfo?.list?.length || 0) ? "All Operating Region Escalation" : "Selected Operating Region Escalation(s)"}`}
                    onDeleteRecords={() => deleteOperatingRegionOperationFn()}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
                    onToggleModal={() => setBulk({ modal: false, ids: [] })}
                /> : null
            }
            {
             revisionHistory.modal &&  
             <RevisionHistory 
              moduleName={"region_escalation"}
              revisionHistory={revisionHistory}
              onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
            />
            }
            <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(OperatingRegion, { application: 'lease_revamp', feature: 'region_escalation', operationType: ['R'], leaseNav: true });
